module.exports = "https://cdn.thelire.com/ins/resource/lh_more_vip_on.a4707a7eb7be3b3cb6c54c80d07d7eff.png";